<template>
  <section class="lawyer-form mt-7 container">
    <div class="wrapper flex p-4">
      <div class="form-container pr-4">
        <h2 class="form-head mb-3">
          Your Companion for Legal Issues
        </h2>
        <div class="tab-container">
          <ul class="tab-list mb-3">
            <li
              v-for="tab in tabs"
              :key="tab"
              :class="['tab-item', { active: currentTab === tab}, 'make_pointer']"
              @click="currentTab = tab"
            >
              <a class="make_pointer">{{ tab }}</a>
            </li>
          </ul>
        </div>
        <div
          id="searchLawyer"
          class="tab-content"
        >
          <SearchALawyer v-if="currentTabComponent == 'SearchALawyer'" />
          <AskALawyer v-else />
        </div>
      </div>
      <div class="image-container">
        <img
          src="../../../images/art_image01.png"
          alt=""
        >
      </div>
    </div>
  </section>
</template>

<script>
import SearchALawyer from './SearchALawyer.vue'
import AskALawyer from './AskALawyer.vue'
export default {
  name: 'SearchAskCard',
  components: {
    SearchALawyer,
    AskALawyer,
  },
  data() {
    return {
      currentTab: 'Search a Lawyer',
      tabs: ['Search a Lawyer', 'Ask a Lawyer'],
    }
  },
  computed: {
    currentTabComponent: function() {
      if (this.currentTab === 'Ask a Lawyer') {
        return 'AskALawyer'
      }
      return 'SearchALawyer'
    },
  },
}
</script>
<style scoped>
  .mt-7{
    margin-top: 7rem !important;
  }

  .flex{
    align-items: start !important;
  }
</style>
